exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-invite-friends-tsx": () => import("./../../../src/pages/invite-friends.tsx" /* webpackChunkName: "component---src-pages-invite-friends-tsx" */),
  "component---src-pages-sports-tsx": () => import("./../../../src/pages/sports.tsx" /* webpackChunkName: "component---src-pages-sports-tsx" */)
}

